import React from 'react';
import {
  Grid, Card, CardContent, Typography,
} from '@mui/material';
import {
  People as PeopleIcon,
  Home as HomeIcon,
  Schedule as ScheduleIcon,
  Description as DescriptionIcon,
  Timeline as TimelineIcon,
  Notifications as NotificationsIcon,
  AutoAwesome as AutoAwesomeIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const kpiConfig = [
  {
    key: 'contacts', label: 'Contacts', icon: <PeopleIcon color="primary" sx={{ fontSize: 32 }} />, route: '/crm/contacts',
  },
  {
    key: 'properties', label: 'Properties', icon: <HomeIcon color="success" sx={{ fontSize: 32 }} />, route: '/crm/properties',
  },
  {
    key: 'tasks', label: 'Tasks', icon: <ScheduleIcon color="info" sx={{ fontSize: 32 }} />, route: '/crm/tasks',
  },
  {
    key: 'notes', label: 'Notes', icon: <DescriptionIcon color="secondary" sx={{ fontSize: 32 }} />, route: '/crm/notes',
  },
  {
    key: 'leadStages', label: 'Lead Stages', icon: <TimelineIcon color="action" sx={{ fontSize: 32 }} />, route: '/crm/lead-stages',
  },
  {
    key: 'notifications', label: 'Notifications', icon: <NotificationsIcon color="warning" sx={{ fontSize: 32 }} />, route: '/crm/notifications',
  },
  {
    key: 'aiFields', label: 'AI Fields', icon: <AutoAwesomeIcon color="primary" sx={{ fontSize: 32 }} />, route: '/crm/ai-fields',
  },
];

export default function CrmKpiCards({ stats }) {
  const navigate = useNavigate();
  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {kpiConfig.map(({
        key, label, icon, route,
      }) => (
        <Grid item xs={6} sm={4} md={2} key={key}>
          <Card
            sx={{
              textAlign: 'center', minHeight: 120, cursor: 'pointer', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.03)' },
            }}
            onClick={() => navigate(route)}
          >
            <CardContent>
              {icon}
              <Typography variant="h5" fontWeight={700}>
                {stats[key] ?? 0}
              </Typography>
              <Typography color="text.secondary" fontSize={14}>{label}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
